// extracted by mini-css-extract-plugin
module.exports = {"categories-card":"category_categories-card__6ybsx","first-sub-category":"category_first-sub-category__eTyVf"};